export default function About() {
  const features = [
    {
      icon: 'ri-lightbulb-flash-line',
      title: 'Creatividad sin límites',
      description: 'Cada diseño es único y personalizado para tu marca'
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Atención personalizada',
      description: 'Trabajamos contigo en cada paso del proceso creativo'
    },
    {
      icon: 'ri-time-line',
      title: 'Entregas rápidas',
      description: 'Cumplimos con los plazos sin comprometer la calidad'
    },
    {
      icon: 'ri-award-line',
      title: 'Calidad profesional',
      description: 'Diseños de alta calidad listos para usar en cualquier medio'
    }
  ];

  return (
    <section id="sobre-nosotros" className="py-24 bg-gradient-to-b from-[#2d1b4e] via-[#1a0b2e] to-[#0f0520] relative overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-1/4 left-0 w-96 h-96 bg-[#ff00aa] rounded-full mix-blend-screen filter blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/4 right-0 w-96 h-96 bg-[#00ffff] rounded-full mix-blend-screen filter blur-3xl animate-pulse" style={{ animationDelay: '1.5s' }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <div className="inline-block bg-gradient-to-r from-[#ff00ff]/20 to-[#00ffff]/20 backdrop-blur-sm border border-[#00ffff]/30 px-5 py-2 rounded-full mb-6">
              <span className="text-xs font-bold text-[#00ffff] uppercase tracking-wide">
                Sobre Nosotros
              </span>
            </div>
            <h2 className="text-5xl md:text-6xl font-bold text-white mb-6">
              Transformamos ideas en diseños memorables
            </h2>
            <p className="text-xl text-[#c0c0ff] leading-relaxed mb-8">
              En <strong className="text-[#00ffff]">Logo Ideas</strong>, somos una agencia creativa especializada en diseño gráfico profesional. Ayudamos a emprendedores, negocios locales y empresas a crear una identidad visual impactante que conecte con su audiencia.
            </p>
            <p className="text-lg text-[#c0c0ff] leading-relaxed mb-8">
              Nuestro equipo combina creatividad, experiencia y atención al detalle para entregar diseños que no solo se ven bien, sino que comunican la esencia de tu marca y generan resultados reales.
            </p>

            {/* Features Grid */}
            <div className="grid sm:grid-cols-2 gap-6">
              {features.map((feature, index) => (
                <div key={index} className="flex gap-4">
                  <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gradient-to-br from-[#ff00ff] to-[#00ffff] flex-shrink-0 shadow-lg shadow-[#ff00ff]/50">
                    <i className={`${feature.icon} text-2xl text-white`}></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-white mb-1">{feature.title}</h3>
                    <p className="text-sm text-[#c0c0ff]">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative bg-gradient-to-br from-[#ff00ff]/20 to-[#00ffff]/20 backdrop-blur-sm border border-[#00ffff]/30 rounded-3xl p-8 overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-b from-[#ff00ff]/10 via-transparent to-[#00ffff]/10"></div>
              <div className="w-full h-96">
                <img
                  src="https://public.readdy.ai/ai/img_res/3b062f3feb2dfd7b7a59c060fa881b2d.jpg"
                  alt="Equipo Logo Ideas"
                  className="w-full h-full object-cover rounded-2xl shadow-2xl"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
